import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import ApprovalPanel from './ApprovalPanel';
import type { ApprovalPanelProps, ApprovalPanelAPI, ApprovalPanelHandle } from './types';

declare global {
  interface Window {
    mountApprovalPanel: (containerId: string, props: ApprovalPanelProps) => ApprovalPanelHandle;
  }
}

window.mountApprovalPanel = function mountApprovalPanel(
  containerId: string,
  props: ApprovalPanelProps,
): ApprovalPanelHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('ApprovalPanel: container not found:', containerId);
    return { unmount: () => {}, get api() { return null; } };
  }

  const apiRef = createRef<ApprovalPanelAPI>();
  const root = createRoot(container);
  root.render(React.createElement(ApprovalPanel, { ...props, ref: apiRef }));

  return {
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};
